import { Link } from 'react-router';
import { Notice, formatDate, useAuth, type AuthTenant } from '@saas/ui';

/**
 * 解約手続き中の帯（03 §6.3 ④）。
 *
 * 猶予の間はログインできるが、書き込みはサーバが 403（TENANT_READ_ONLY）で止める。
 * 何が起きているのかと、いつまで見られるのかを常に見えるところに出す。
 *
 * 置き場所はシェル（apps/web の Shell）。`<ReadOnlyBanner />` を Header の下に 1 行置くだけでよい
 * （解約していないテナントでは何も描かない）。
 */
export function ReadOnlyBanner() {
  const { me, can } = useAuth();
  // @saas/ui の AuthTenant（全モジュール共通の型）は広げない。GET /auth/me が足した分だけをここで読む
  const tenant = me?.tenant as
    | (AuthTenant & { readOnly?: boolean; readOnlyReason?: 'TENANT_READ_ONLY' | 'TRIAL_EXPIRED' | null; deleteAfter?: string | null; trialEndsOn?: string | null })
    | undefined;
  if (!tenant?.readOnly) return null;

  // 段 5: トライアル切れ（02 §5.1）。解約とは理由が違うので、誘導先も変える
  if (tenant.readOnlyReason === 'TRIAL_EXPIRED') {
    return (
      <div className="px-4 pt-3">
        <Notice tone="warning" title="無料トライアルが終了しました">
          <p>
            {tenant.trialEndsOn ? `${formatDate(tenant.trialEndsOn)} で終了しました。` : null}
            契約手続きが済むまで、閲覧とデータの書き出しのみ行えます。データは消えていません。
          </p>
          {can('core.billing.read') ? (
            <p className="mt-1">
              <Link to="/admin/subscription" className="underline">
                契約とプランの画面を開く
              </Link>
            </p>
          ) : null}
        </Notice>
      </div>
    );
  }

  const until = tenant.deleteAfter ? formatDate(tenant.deleteAfter) : null;
  return (
    <div className="px-4 pt-3">
      <Notice tone="warning" title="解約手続き中です">
        <p>
          {until ? `${until} まで閲覧とデータのエクスポートができます。` : 'データのエクスポートと受領確認が終わるまで、閲覧のみ行えます。'}
          この間、新しい登録や編集はできません。
        </p>
        {can('core.export.execute') ? (
          <p className="mt-1">
            <Link to="/admin/exports" className="underline">
              解約とデータ返還の画面を開く
            </Link>
          </p>
        ) : null}
      </Notice>
    </div>
  );
}
